export function isNullish(value: any): value is null | undefined {
  return value === null || typeof value === 'undefined'
}

export function isNotNullish<T>(value: T): value is Exclude<T, null | undefined> {
  return !isNullish(value)
}

export const isIterable = (value: unknown): boolean => typeof value === 'object' && value !== null && Symbol.iterator in value;